/**
 * Constants for Learning Development Component
 */

export const LEARNING_DEVELOPMENT = {
  // Text values
  TEXT: {
    YES: 'Yes',
    NO: 'No',
    LOADING_ERROR: 'Failed to load learning and development data',
    TITLE: 'Learning & Development',
    SEARCH: 'Search',
    NO_DATA_ALT: 'No data found'
  },
  
  // Column headers
  COLUMNS: {
    NAME: 'Name',
    QUARTER: 'Quarter',
    TRAINING: 'Mandatory 10hr Training',
    CERTIFICATION: 'No of Certification Acquired',
    FULLSTACK: 'Upskilled to Fullstack',
    AI_SKILLS: 'AI/ML and Gen AI Skills'
  },
  
  // Pagination configuration
  PAGINATION: {
    ENABLED: true,
    DEFAULT_PAGE_SIZE: 25,
    PAGE_SIZE_OPTIONS: [25, 50],
    MAX_HEIGHT: 475
  },
  
  // API-related constants
  API: {
    ENDPOINT: '/hiring/quarterly-feedback/learning-development',
    PARAM_VENDOR_ID: 'vendorId',
    PARAM_EMPLOYEE_ID: 'employeeId',
    PARAM_QUARTER: 'quarter',
    PARAM_YEAR: 'year'
  },
  
  // Quarter formats
  QUARTER: {
    FORMAT_REGEX: /^Q[1-4]$/,
    NUMBER_REGEX: /^[1-4]$/,
    PREFIX: 'Q',
    MIN: 1,
    MAX: 4
  }
};
